import dayjs from "dayjs";
import { ChevronRight, Search } from "lucide-react";
import React from "react";

import { articles } from "../../articles";
import { Input } from "../../components/ui/input";
import Layout from "./Layout";

const ArticleItem = ({ title, description, link, date }) => {
	return (
		<div className="bg-white rounded-lg shadow p-4">
			<p className="text-sm text-gray-500 mr-auto mb-2">Published on {dayjs(date).format("MMMM D, YYYY")}</p>
			<h2 className="text-md font-bold mb-2 leading-tight">{title}</h2>
			<p className="text-gray-700 mb-4">{description}</p>
			<a href={link} className="text-blue-500 hover:underline flex items-center leading-none justify-end pt-2">
				Learn More <ChevronRight size={16} className="inline" />
			</a>
		</div>
	);
};

function BlogCategories() {
	return (
		<Layout>
			<section className="max-w-7xl mx-auto px-4 md:px-8 py-16 bg-white">
				<h1 className="font-bold text-5xl font-plus-jakarta">Articles</h1>
				<p className="font-inter text-[#333333] text-xl mt-4">
					Explore our collection of articles that provide insights, tips, and stories to help you navigate your career
					path. From job search strategies to professional development, find valuable resources to enhance your journey.
				</p>
			</section>
			<section className=" bg-gray-50">
				<div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
					<div className="*:not-first:mt-2">
						<div className="relative">
							<Input className="peer ps-9 max-w-2xl bg-white" placeholder="Search" type="text" />
							<div className="text-muted-foreground/80 pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 peer-disabled:opacity-50">
								<Search size={16} aria-hidden="true" />
							</div>
						</div>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
						{articles.map((item) => (
							<ArticleItem
								key={item.slug}
								title={item.title}
								description={
									item.excerpt
										.replace(/<[^>]+>/g, "")
										.slice(0, 240)
										.trim() + "..."
								}
								link={"/articles/" + item.slug}
								date={item.date}
							/>
						))}
					</div>
				</div>
			</section>
		</Layout>
	);
}

export default BlogCategories;
